<mat-card class="cardT">Usuários</mat-card>
<div>
  <app-lista-dados
    [upTitulo]="'Lista de Usuários'"
    [upIcone]="'people'"
    [upCor]="'3F51B5'"
    [upDados]="usuarios"
    [upColunas]="colunasListaDados"
    [upHabilitaEditarLinha]="false"
    [upLargura]="2"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    [upCarregando]="!!subscription"
    (ueBotaoIncluir)="onCreate()"
    (ueBotaoEditar)="onEdit($event)"
    (ueBotaoExcluir)="onDelete($event)">
  </app-lista-dados>
</div>

